import { Image } from '@ssv-website/web-ui';
import co_creation_icon from '@/assets/icons/co_creation_icon.png';
import Link from 'next/link';
import { CosImage } from '@ssv-website/web-ui';
interface IProps {
  title: string;
  text: string;
  count: number;
  imgUrl: string;
  link: string;
  isMobile?: boolean;
  path?: string;
}

const CreationCard = (props: IProps) => {
  const { title, text, count, imgUrl, link, isMobile, path } = props;
  const cs = isMobile ? mobile_class : desktop_class;

  return (
    <Link href={link} className="block h-full" target="_blank">
      <div
        className={`bg-white overflow-hidden h-full flex flex-col ${cs.box}`}
      >
        <div className={cs.img_box}>
          {path ? (
            <CosImage
              fallbackSrc={imgUrl as any}
              path={path}
              alt=""
              className={cs.img}
              width={540}
              height={480}
            />
          ) : (
            <Image
              src={imgUrl}
              alt=""
              className={cs.img}
              width={540}
              height={480}
            />
          )}
        </div>
        <div className={` flex flex-col flex-1 ${cs.content_box}`}>
          <div
            className={`text-primary  mobile:leading-6 line-clamp-2 text-ellipsis ${cs.title}`}
          >
            {title}
          </div>
          <div
            className={`text-tips leading-6 mobile:leading-5 line-clamp-3 text-ellipsis ${cs.text}`}
          >
            {text}
          </div>
          <div className="flex-1 flex self-end">
            {!isMobile && (
              <span className="text-primary hover:text-active cursor-pointer self-end">
                查看详情
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CreationCard;

const desktop_class = {
  box: 'flex-1 bg-cover pb-5 group w-full rounded-lg hover:bg-[url(../assets/images/co_creation_card_bg.png)] cursor-pointer',
  img_box: 'w-full aspect-[267/154] overflow-hidden',
  img: 'w-full aspect-[267/154] group-hover:scale-110 transition-all duration-700',
  content_box: 'p-4 ',
  title: 'text-2xl pt-[0.5rem] mb-2',
  text: 'mb-5 text-base',
  count: 'text-xs',
};

const mobile_class = {
  box: 'w-[12.25rem] pb-2 rounded-md bg-gradient-to-r from-[#F1FFF6] to-[#E7F1FE]',
  img_box: '',
  img: 'w-full aspect-[267/154]',
  content_box: 'p-2',
  title: 'text-[1.125rem] pt-3 mb-1 ',
  text: 'text-xs mb-[0.62rem]',
  count: 'text-xss',
};
